export interface PromptModel {
  label: string;
  question: string;
  promptDataTypeId: PromptDataType;
  objectIdentifier: string;
  description: string;
}

export enum PromptDataType {
  Boolean = 1,
  ListOfValues = 2,
  RangeOfValues = 3,
  Text = 4,
  Generative = 5,
  Date = 6,
}
